export default __webpack_public_path__ + "static/LeituraDisplayTwo-Roman-c094e29dfe9d3df217327fd3e0d6fad9.woff2";